(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.desktopMegaMenuMedia = window.matchMedia('(min-width: 990px)');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const wasScrolledPastHeader = this.header.classList.contains('scrolled-past-header');
      const willChangeScrolledState =
        (!wasScrolledPastHeader && scrollTop > this.headerBounds.bottom) ||
        (wasScrolledPastHeader && scrollTop <= this.headerBounds.top);
      const openMegaMenuContent = willChangeScrolledState ? this.getOpenDesktopMegaMenuContent() : null;
      const previousMegaMenuTop = openMegaMenuContent?.getBoundingClientRect().top;

      // Close all search dropdowns (popular suggestions + predictive results) on scroll
      this.closePopularSuggestions();
      this.closePredictiveSearch();

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!wasScrolledPastHeader) this.syncDesktopMegaMenuPosition(openMegaMenuContent, previousMegaMenuTop);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!wasScrolledPastHeader) this.syncDesktopMegaMenuPosition(openMegaMenuContent, previousMegaMenuTop);
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (wasScrolledPastHeader) this.syncDesktopMegaMenuPosition(openMegaMenuContent, previousMegaMenuTop);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    getOpenDesktopMegaMenuContent() {
      if (!this.desktopMegaMenuMedia.matches) return;

      return this.querySelector('.header__inline-menu header-menu > details[open] .mega-menu__content');
    }

    syncDesktopMegaMenuPosition(megaMenuContent, previousTop) {
      if (!megaMenuContent) return;

      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.round(this.getBoundingClientRect().bottom)}px`
      );

      if (typeof previousTop !== 'number') return;

      const nextTop = megaMenuContent.getBoundingClientRect().top;
      const offset = Math.round(previousTop - nextTop);
      if (Math.abs(offset) <= 1) return;

      megaMenuContent.style.setProperty('--mega-menu-position-offset', `${offset}px`);
      megaMenuContent.getBoundingClientRect();

      requestAnimationFrame(() => {
        megaMenuContent.style.setProperty('--mega-menu-position-offset', '0px');

        window.clearTimeout(this.megaMenuPositionOffsetTimeout);
        this.megaMenuPositionOffsetTimeout = setTimeout(() => {
          megaMenuContent.style.removeProperty('--mega-menu-position-offset');
        }, 240);
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    closePopularSuggestions() {
      // Close suggestions inside sticky header
      this.querySelectorAll('search-form[popular-open], predictive-search[popular-open]').forEach(el => {
        if (typeof el.hidePopularSuggestions === 'function') el.hidePopularSuggestions();
        const input = el.querySelector('input[type="search"]');
        if (input) input.blur();
      });
      // Also close suggestions in the mobile/inline search outside sticky-header
      document.querySelectorAll('search-form[popular-open], predictive-search[popular-open]').forEach(el => {
        if (typeof el.hidePopularSuggestions === 'function') el.hidePopularSuggestions();
        const input = el.querySelector('input[type="search"]');
        if (input) input.blur();
      });
    }

    closePredictiveSearch() {
      // Close all predictive search results and blur inputs
      document.querySelectorAll('predictive-search').forEach(el => {
        if (el.isOpen && typeof el.close === 'function') {
          el.close();
        }
        const input = el.querySelector('input[type="search"]');
        if (input) input.blur();
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
